import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';

function AsteriaParanaque() {

    return (
        <>
            <Header />
            <section id='asteria-panaraque'>
                <div className='container'>
                    <div className='row my-5'>
                        <h4 className='text-primary text-start mb-0'>2 Bedroom with Balcony and Parking in Asteria Residences, Parañaque City</h4>
                        <p className='text-start'> <small><i class="bi bi-pin-map-fill"></i> San Isidro Sucat, Paranaque</small></p>
                        <div className='row mb-3'>
                            <div className='col-lg-5'>
                                <div className='text-start'>
                                    <p className='mb-0'><b>About Asteria Residences</b></p>
                                    <p>
                                        <small>
                                            By residing in these townships, essential establishments are easily accessible from your Condominium in Parañaque.
                                            These establishments may be co-working spaces, entertainment hubs, retail shops, dining places, fitness centers,
                                            banks, and landscaped parks. You can also reach schools, hospitals, offices, shopping centers, convenience stores,
                                            and different transportation and road systems in San Isidro without hassle while enjoying a Condominium with a value
                                            increasing over time.
                                            <br />
                                            <br />
                                            On top of this, your Condominium in Parañaque hosts plenty of recreational facilities that you can enjoy all year long.
                                            From swimming pools and clubhouses to function halls, multipurpose courts, and activity centers, you can embrace
                                            different hobbies and interests and maximize your investment, as it grows in value.
                                            <br />
                                            <br />
                                            As you compare prices, don’t forget to consider the types of model units and floor areas and make sure that your next
                                            Condominium in Metro Manila suits your modern lifestyle. Maximize your cash with a purchase of a Condominium in San Isidro.
                                            In San Isidro, Parañaque you’ll be able to find mixed-use developments that will let you embrace convenient and, more
                                            importantly, practical living.
                                        </small>
                                    </p>
                                </div>
                            </div>
                            <div className='col-lg-7'>
                                <div id="SomaTaguigProject" className="carousel slide" data-bs-ride="carousel">
                                    <div className="carousel-indicators">
                                        <button type="button" data-bs-target="#SomaTaguigProject" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                        <button type="button" data-bs-target="#SomaTaguigProject" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                        <button type="button" data-bs-target="#SomaTaguigProject" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                        <button type="button" data-bs-target="#SomaTaguigProject" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                        <button type="button" data-bs-target="#SomaTaguigProject" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                        <button type="button" data-bs-target="#SomaTaguigProject" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                        <button type="button" data-bs-target="#SomaTaguigProject" data-bs-slide-to="6" aria-label="Slide 7"></button>
                                    </div>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/MainEntrance.jpg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/MainEntrance.jpg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/SwimmingPool.jpg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/SwimmingPool.jpg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/PlayGround.jpg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/PlayGround.jpg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/Lounge.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/Lounge.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/GameArea.jpg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/GameArea.jpg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/FunctionHall.jpg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/FunctionHall.jpg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/FitnessGym2.jpg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/FitnessGym2.jpg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                    </div>
                                    <button className="carousel-control-prev" type="button" data-bs-target="#SomaTaguigProject" data-bs-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button className="carousel-control-next" type="button" data-bs-target="#SomaTaguigProject" data-bs-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </div>
                                <p className='d-xxl-none d-xl-none d-xxl-block d-lg-none d-xl-block'> <small><i>Tap to Enlarge</i></small></p>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className='col-lg-8'>
                                <iframe width="100%" height="600rem"
                                    title="XQVNmgdYRUQ"
                                    src="https://www.youtube.com/embed/6O8I1VWenuk?autoplay=1&controls=1&loop=0&mute=1&rel=0&start=0">
                                </iframe>
                            </div>
                            <div className='col-lg-4'>
                                <div className='text-start text-small'>
                                    <b>Description:</b>
                                    <ul>
                                        <small>
                                            <li>2 Bedroom</li>
                                            <li>1 Toilet and Bath</li>
                                            <li>61 sqm (656.599 sqft) </li>
                                            <li>1 Parking Slot</li>
                                        </small>
                                    </ul>

                                    <b>Other Features:</b>
                                    <ul>
                                        <small>
                                            <li>1 drying cage </li>
                                            <li>1 utility area </li>
                                            <li>1 washing area</li>
                                            <li>Big Balcony</li>
                                        </small>
                                    </ul>

                                    <b>Others Details:</b>
                                    <p>Vicinity
                                        <br />
                                        <small>
                                            The project is located in San Antonio Valley 2, where houses surrounding the project
                                            bring out a sense of quiet and calm. Just a few minutes away, you find many establishments
                                            in Parañaque - from malls to supermarkets and restaurants.
                                        </small>
                                        <br />
                                        <br />
                                        Ownership
                                        <br />
                                        <small>
                                            Freehold or perpetual ownership. Foreigners can buy into the complex as 40% of total units in is allowed for foreign buyers.
                                        </small>
                                    </p>

                                    <div class="d-flex justify-content-start">
                                        <p class="text-start text-white m-0 px-2 border border-info border-3 rounded-pill bg-info">
                                            <small><b>Php 5, 995, 000.00</b></small>
                                        </p>
                                    </div>
                                    <p>
                                        <small>
                                            Available for Viewing
                                        </small>
                                    </p>
                                    <div className='d-flex flex-row'>
                                        <a className='btn btn-success' href='/contact-us'>Contact us for Viewing</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <h4 className='text-start text-primary'>Amenities and Location</h4>
                            <div className='row mb-3'>
                                <div className='col-lg-7'>
                                    <a href="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/ListingSale/AsteriaParanaque/Amenities.jpg">
                                        <img className="img-fluid pt-4"
                                            src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingSale/AsteriaParanaque/Amenities.jpg"
                                            alt="...">
                                        </img>
                                    </a>
                                    <p className='d-xxl-none d-xl-none d-xxl-block d-lg-none d-xl-block'> <small><i>Tap to Enlarge</i></small></p>
                                </div>
                                <div className='col-lg-5 text-start'>
                                    <p className='mb-0'><b>The Asteria Amenities</b></p>
                                    <p>
                                        <small>
                                            The medium-rise development is sprawled efficiently on prime land, in San Antonio Valley 2, Barangay San Isidro,
                                            Sucat Parañaque City. Residents and upgraders from Sucat Parañaque City and surrounding cities gets another opportunity
                                            to be part of a DMCI Homes community.
                                            <br />
                                            <br />
                                            Like other DMCI Homes’ communities, Asteria Residences is a distinct architectural theme with a nature-rich setting and
                                            eco-friendly environment and offers first-rate building features, generously spaced units, exclusivity and security,
                                            property management services, plus an affordable pricing scheme.
                                            <br />
                                            <br />
                                            Southern Manila is generally known for its laid-back culture. While majority of the residences in the area are houses,
                                            Asteria Residences is a project that won’t fall out of place with units designed for a lock-and-go lifestyle. Our 24-hour
                                            security and Property Management Officers ensure that your home is safe and secure while you go about on your usual day.
                                            <br />
                                            <br />
                                            Nothing beats spending a day hanging out with friends or loved ones. With Asteria’s resort-themed amenities, relaxation
                                            is something that can be enjoyed not only by your own family but with neighbours and friends. All it takes is a few steps
                                            out the door.
                                        </small>
                                    </p>

                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-5 text-start'>
                                    <b>About Panaraque City</b>
                                    <p>
                                        <small>
                                            Parañaque may be located in the southern part of Metro Manila, but it doesn’t mean
                                            it is accessible to the rest of the metro, including central business districts and
                                            important points of interest. The city is bordered to the north by the city of Pasay,
                                            to the northeast by Taguig, to the southeast by Muntinlupa, to the southwest by Las Piñas,
                                            and to the west by Manila Bay.
                                            <br />
                                            <br />
                                            People can easily commute to and from Parañaque using the major road systems, including the NAIA Expressway – E6,
                                            Elpidio Quirino Avenue, and Ninoy Aquino Avenue. Moreover commuters can also take alternative routes that pass
                                            through the city’s neighboring cities, Las Piñas, and Muntinlupa, with main gates leading to each of them.
                                            This is great especially when the city’s main throughways such as Alabang-Zapote Road or Dr. A Santos Avenue
                                            (formerly Sucat Road) are experiencing heavy traffic. Parañaque is also close to neighboring provinces such as
                                            Cavite and Batangas. As such, it is quite easier to schedule a much-needed vacation away from the metro temporarily.
                                        </small>
                                    </p>
                                </div>
                                <div className='col-lg-7'>
                                    <iframe className="embed-responsive-item"
                                        width="100%" height="400rem"
                                        src="https://maps.google.com/maps?q=Asteria%20Residences,%20Paranaque&t=&z=15&ie=UTF8&iwloc=&output=embed"
                                        frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>

            <Footer />
        </>
    )
}

export default AsteriaParanaque